<template>
  <div id="app">
    <router-view />

    <!-- 注册成功页面 -->
    <RegisterSuccess />

    <!-- 操作菜单组件 -->
    <van-action-sheet
      v-model="action_sheet_show"
      cancel-text="取消"
      :actions="action_sheet_list"
      style="border-radius: 0;"
      :close-on-click-action="true"
      @select="ActionSheetSelect"
      @cancel="ActionSheetCancel"
      @click-overlay="ActionSheetCancel"
    />
  </div>
</template>

<script>

  import { mixin as InteractiveMixins } from '@/utils/Interactive'
  export default {
    data () {
      return {
        title: '金泉涞'
      }
    },
    name: 'app',
    mixins: [InteractiveMixins],
    watch: {
      $route () {
        this.getWxJssdk()
        $(document).scrollTop(0)
        if (this.$route.meta) {
          // 阻止切换动画
          this.transition_name = this.$route.meta.isNotAnimation
            ? ''
            : 'slide-fade'
        }
        // 显示页面标题
        document.title = this.$route.meta.title
          ? this.$route.meta.title
          : this.title
      }
    }
  }
</script>

<style></style>
